/**
 * Shared message templates used by both the worker and the landing page demo.
 * Keep these in sync to ensure consistent user experience.
 */

// Queue state messages
export const MSG_QUEUE_EMPTY = "Queue is empty.";
export const MSG_QUEUE_EMPTY_NOTHING_DONE = "Queue is empty. Nothing to mark done.";
export const MSG_NO_PENDING_ITEMS = "No pending items to mark as done.";
export const MSG_NO_UNASSIGNED_ITEMS = "No unassigned items in queue. Use `!add <item>` first.";

// Success messages
export const msgAddedToQueue = (text: string) => `Added to queue: "${text}"`;
export const msgDone = (text: string) => `Done: ${text}`;
export const msgMarkedDone = (user: string) => `Marked as done! @${user} has been notified.`;
export const msgTaskAssigned = (name: string) => `Task assigned to ${name}`;
export const msgTaskAddedAndAssigned = (name: string) =>
  `Task added to queue and assigned to ${name}`;

// Error messages
export const MSG_ADD_USAGE = "Usage: `!add <item>`";
export const MSG_DUPLICATE_ITEM = "This item is already in the queue.";
export const MSG_CANT_ADD_BOT_MESSAGE = "You can't add a Kyubot message.";
export const MSG_CANT_TAKE_BOT_MESSAGE = "You can't take a Kyubot message.";
export const MSG_CANT_ASSIGN_BOT_MESSAGE = "You can't assign a Kyubot message.";
export const MSG_ASSIGN_USAGE_THREAD = "Usage: `!assign @user` must be used in a thread.";
export const MSG_ASSIGN_USAGE_TAG = "Usage: `!assign @user` - you must tag a user.";
export const msgNoItemMatching = (arg: string) => `No item matching "${arg}" found.`;
export const msgMultipleMatches = (arg: string) =>
  `Multiple items match "${arg}". Be more specific or use a number.`;
export const MSG_ALREADY_ASSIGNED = "This item is already assigned.";

// List formatting
export const msgQueueHeader = (count: number) =>
  `*Queue (${count} item${count === 1 ? "" : "s"}):*`;
export const msgQueueMore = (remaining: number) => `\n\n_...and ${remaining} more_`;
